import { Modal, Button, Flex, Text } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";

import { useConsentModalTranslate } from "./hooks";
import { changeConsentRequest, openConsentModalAtom } from "./store";

export const ConsentModal = () => {
  const [open] = useAtom(openConsentModalAtom);
  const [loading] = useAtom(changeConsentRequest.isLoadingAtom);

  const changeConsent = useAction(changeConsentRequest);

  const { title, description, agreement, disagreement } =
    useConsentModalTranslate();

  const handleDecision = (value: boolean) => {
    changeConsent({ consentToCommunications: value });
  };

  return (
    <Modal open={open}>
      <Flex direction="column" gap="4" style={{ padding: 24, maxWidth: 420 }}>
        <Text variant="header-1">{title}</Text>
        <Text>{description}</Text>
        <Flex gap="2">
          <Button
            view="normal"
            loading={loading}
            onClick={() => handleDecision(false)}
          >
            {disagreement}
          </Button>
          <Button
            view="action"
            loading={loading}
            onClick={() => handleDecision(true)}
          >
            {agreement}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
